// extracted by mini-css-extract-plugin
export default {"container":"Inventories_container__SA3c9"};